import { ReactNode } from "react";
import styled from "@emotion/styled";
import IconButton from "@mui/material/IconButton";
import { interactive, surface, spacing, borderRadius } from "@atlas-int/tokens";
import ControlRow from "@atlas-int/ui/ControlRow";

const TradeDirectionList = styled.ul`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0px;
  margin: 0px;
  list-style-type: none;
  padding: 0px;

  & a {
    text-decoration: none;
    color: inherit;
  }

  & li:hover {
    cursor: pointer;
    color: ${interactive.default};
    background-color: ${surface.hover};
    border-radius: ${borderRadius.base};
  }
`;

interface MarketsControlPanelProps {
  /** Location dropdown element */
  locationDropdown: ReactNode;
  /** Product dropdown element */
  productDropdown: ReactNode;
  /** Exporter trade direction button */
  exporterButton: ReactNode;
  /** Importer trade direction button */
  importerButton: ReactNode;
  /** Called when trade direction is swapped */
  onTradeDirectionSwap: () => void;
  /** Icon source for the swap button */
  swapIconSrc?: string;
}

export const MarketsControlPanel = ({
  locationDropdown,
  productDropdown,
  exporterButton,
  importerButton,
  onTradeDirectionSwap,
  swapIconSrc,
}: MarketsControlPanelProps) => {
  return (
    <>
      <ControlRow
        label={
          <TradeDirectionList>
            {exporterButton}
            <IconButton
              onClick={onTradeDirectionSwap}
              aria-label="Swap Importer and Exporter"
              size="small"
              sx={{ padding: spacing[1] }}
            >
              {swapIconSrc && (
                <img
                  style={{ width: spacing[6], height: spacing[6] }}
                  src={swapIconSrc}
                  alt=""
                />
              )}
            </IconButton>
            {importerButton}
          </TradeDirectionList>
        }
        inputWidth="160px"
        flex
        maxWidth="275px"
      >
        {locationDropdown}
      </ControlRow>
      <ControlRow label="Products" inputWidth="160px" flex maxWidth="275px">
        {productDropdown}
      </ControlRow>
    </>
  );
};
